import { render, staticRenderFns } from "./bonusRecord.vue?vue&type=template&id=13874049&"
import script from "./bonusRecord.vue?vue&type=script&lang=js&"
export * from "./bonusRecord.vue?vue&type=script&lang=js&"
import style0 from "./bonusRecord.vue?vue&type=style&index=0&id=13874049&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports